import { axiosInstance } from "./";

const createAnimation = async (payload) =>
  await axiosInstance.post("/public_event_animations", payload);

const getAnimations = async (params) =>
  await axiosInstance.get("/public_event_animations", { params });

const getAnimationDetails = async (id) =>
  await axiosInstance.get(`/public_event_animations/${id}`);

const deleteAnimation = async (id) =>
  await axiosInstance.delete(`/public_event_animations/${id}`);

const editAnimation = async ({ id, data }) =>
  await axiosInstance.patch(`/public_event_animations/${id}`, data);

export { createAnimation, getAnimations, getAnimationDetails, deleteAnimation, editAnimation };
